$(document).ready(function() {
    //語系
    const lang = $('.lang');

    lang.hide();
    $('.ch').show();

    $('.lang_btn').click(function() {
        let _lang = $(this).data('lang');
        lang.hide();
        $('.' + _lang).show();
    });
})